import * as THREE from "three";

export function fitShadowCameraToScene(light, root, padding = 2) {
  const box = new THREE.Box3().setFromObject(root);
  const sphere = box.getBoundingSphere(new THREE.Sphere());
  const { center, radius } = sphere;
  const distance = radius * 2;
  const direction = light.position.clone().normalize();

  light.position.copy(center).addScaledVector(direction, distance);
  light.target.position.copy(center);
  light.target.updateMatrixWorld();

  const camera = light.shadow.camera;
  camera.left = -radius;
  camera.right = radius;
  camera.top = radius;
  camera.bottom = -radius;
  camera.near = Math.max(0.1, distance - radius - padding);
  camera.far = distance + radius + padding;
  camera.updateProjectionMatrix();
}
